// Logic for the roster pages
var GradeLevel = require("lib/academic/GradeLevel");

var StudentRoster = function(rosterData) {
	this.rosterData = rosterData;

	/////////////////////////////////
	// Get lists of column names ////
	/////////////////////////////////

	this.currentColumns = _.memoize(function() {
		return _.keys(this.rosterData);
	})

	this.missingColumns = function() {
		return _.difference(REQUIRED_COLUMNS, this.currentColumns());
	}
	this.unrecognizedColumns = function() {
		return _.difference(this.currentColumns(), RECOGNIZED_COLUMNS);
	}

	/////////////////////////////////////////
	// Get data on students missing data ////
	/////////////////////////////////////////
	this.studentsMissingColumns = function() {
		var missingStudents = []
		var data = this.rosterData;

		for (var i = 0; i < data[FIRST_NAME].length; i++) {
			var missingCols = [];
			var firstName, lastName, gradeLevel, classroom;

			if (data[FIRST_NAME] && data[FIRST_NAME][i]) {
				firstName = data[FIRST_NAME][i];
			} else { firstName = null }

			if (data[LAST_NAME] && data[LAST_NAME][i]) {
				lastName = data[LAST_NAME][i];
			} else { lastName = null }

			if (data[GRADE_LEVEL] && data[GRADE_LEVEL][i]) {
				gradeLevel = data[GRADE_LEVEL][i];
			} else { gradeLevel = null }

			if (data[CLASSROOM] && data[CLASSROOM][i]) {
				classroom = data[CLASSROOM][i];
			} else { classroom = null }


			if (firstName == null)  { missingCols.push(FIRST_NAME) }
			if (lastName == null)   { missingCols.push(LAST_NAME) }
			if (gradeLevel == null) { missingCols.push(GRADE_LEVEL) }
			if (classroom == null)  { missingCols.push(CLASSROOM) }

			if (missingCols.length > 0) {
				var str = "";

				if (firstName != null)  { str += firstName; }
				if (lastName != null)   { str += " " + lastName; }
				if (gradeLevel != null) { str += ", " + GradeLevel.getName(gradeLevel); }
				if (classroom != null)  { str += ", " + classroom; }

				missingStudents.push({
					studentSummary: str,
					missingColumns: missingCols
				});
			}
		}
		return missingStudents;
	}

	//////////////////////////////////////////
	// Get lists of invalid column values ////
	//////////////////////////////////////////

	this.invalidParentEmails = function() {
		if (this.hasColumn(PARENT_EMAIL)) {
			return _.select(this.getColumn(PARENT_EMAIL), function(email) {
				return email && email.trim().length > 0 && !$wr.isValidEmail(email);
			});
		} else { return []; }
	}
	this.invalidPasswords = function() {
		if (this.hasColumn(PASSWORD)) {
			return _.select(this.getColumn(PASSWORD), function(password) {
				return password && password.trim().length < MIN_PASSWORD_LENGTH;
			});
		} else { return []; }
	}
	this.invalidGradeLevels = function() {
		if (this.hasColumn(GRADE_LEVEL)) {
			return _.select(this.getColumn(GRADE_LEVEL), function(gradeLevel) {
				return !GradeLevel.isValid(gradeLevel);
			});
		} else { return []; }
	}
	this.validUsernames = function() {
		if (this.hasColumn(USERNAME)) {
			return _.select(this.getColumn(USERNAME), function(username) {
				return username.toString().trim().length > 0;
			});
		} else { return []; }
	}

	////////////////////////////////////
	// Check the status of a column ////
	////////////////////////////////////
	this.isRequiredColumn = function(column) {
		return _.includes(REQUIRED_COLUMNS, column);
	}
	this.isOptionalColumn = function(column) {
		return _.includes(OPTIONAL_COLUMNS, column);
	}
	this.isUnknownColumn = function(column) {
		return !_.includes(RECOGNIZED_COLUMNS, column);
	}
	this.isHiddenColumn = function(column) {
		return _.includes(HIDDEN_COLUMNS, column);
	}
	this.hasColumn = function(column) {
		return _.includes(this.currentColumns(), column);
	}


	/////////////////////////////////////
	// Get columns and column values ////
	/////////////////////////////////////
	this.getColumn = function(column) {
		return this.rosterData[column];
	}
	this.getValue = function(column, index) {
		return this.getColumn(column)[index];
	}
	this.getStudents = function() {
		var students = [];
		for (var i = 0; i < this.getColumn(FIRST_NAME).length; i++) {
			students.push({
				first_name: this.getValue(FIRST_NAME, i),
				last_name: this.getValue(LAST_NAME, i),
				grade_level: this.getValue(GRADE_LEVEL, i),
				rosterIndex: i
			});
		}
		return students;
	}

	/////////////////////////////////////////////////////
	// Info and validations on the roster as a whole ////
	/////////////////////////////////////////////////////
	this.rowCount = function() {
		return (this.getColumn(FIRST_NAME) || []).length;
	}

	this.hasAllRequiredColumns = function() {
		return this.missingColumns().length == 0;
	}
	this.hasCombinedNameColumn = function() {
		if (this.hasColumn(FIRST_NAME) || this.hasColumn(LAST_NAME)) {
			return false;
		}

		var col = _.find(this.currentColumns(), function(column) {
			return column.toLowerCase().indexOf("name") != -1;
		});

		if (col == undefined) { return false; }

		var colData = this.getColumn(col);
		var multiWordColCount = _.select(colData, function(str) {
			return str.trim().split(" ").length > 1;
		}).length;

		return multiWordColCount > (colData.length / 2); 
	}
	this.getClassroomGradeLevels = function(classroom) {
		var gradeLevels = [];
		_.each(this.getColumn(CLASSROOM), function(oClassroom, index) {
			if (oClassroom == classroom) {
				gradeLevels.push(this.getValue(GRADE_LEVEL, index));
			}
		}.bind(this));

		return _.uniq(gradeLevels);
	}

	this.getClassroomTeacherEmail = function(classroom) {
		if (!this.hasColumn(TEACHER_EMAIL)) {
			return "";
		}
		
		var email = "";
		_.each(this.getColumn(CLASSROOM), function(oClassroom, index) {
			if (oClassroom == classroom) {
				email = this.getValue(TEACHER_EMAIL, index);
			}
		}.bind(this));

		return email;
	}

	this.allStudentsHaveRequiredColumns = function() {
		return _.all(REQUIRED_COLUMNS, function(col) {
			var colData = this.getColumn(col);
			return colData && _.all(colData, function(val) {
				return val != undefined && val.trim().length > 0;
			}.bind(this));
		}.bind(this));
	}

	/////////////////////////////////////////////
	// Gets mapped columns and column values ////
	/////////////////////////////////////////////
	this.mapColumns = function(mapping) {
		var newRosterData = {};
		_.each(_.keys(mapping), function(origCol) {
			newRosterData[mapping[origCol]] = this.getColumn(origCol);
		}.bind(this));
		return newRosterData;
	}

	this.mapColumnValues = function(column, mapping) {
		var newRosterData = _.clone(this.rosterData);
		_.each(this.rosterData[column], function(value, index) {
			var mappedValue = mapping[value];
			if (mappedValue.trim().length == 0) {
				mappedValue = (column == GRADE_LEVEL) ? "13" : "-";
			}
			this.rosterData[column][index] = mappedValue;
		}.bind(this));
		return newRosterData;
	}

	this.splitNameColumn = function() {
		var nameColumn = _.find(this.currentColumns(), function(column) {
			return column.toLowerCase().indexOf("name") != -1;
		});

		var newRosterData = _.clone(this.rosterData);

		if (nameColumn) {
			newRosterData[FIRST_NAME] = []
			newRosterData[LAST_NAME] = []

			_.each(this.getColumn(nameColumn), function(name) {
				// Reverse the string if it's "Last, First" format
				var names = name.split(",").reverse().join(" ").split(" ");

				// Assume the last word is the last name
				newRosterData[LAST_NAME].push(names.pop().trim());

				// Assume the rest of the string is the first name
				newRosterData[FIRST_NAME].push(names.join(" ").trim());
			});

			delete newRosterData[nameColumn];
		}

		return newRosterData;
	}

	this.mergeStudentIDs = function(indexToStudentIDs) {
		var newRosterData = _.clone(this.rosterData);
		newRosterData[STUDENT_ID] = [];
		for (var i = 0; i < newRosterData[FIRST_NAME].length; i++) {
			if (_.has(indexToStudentIDs, i)) {
				newRosterData[STUDENT_ID][i] = indexToStudentIDs[i] + "";
			} else {
				newRosterData[STUDENT_ID][i] = "";
			}
		}

		return newRosterData;
	}
}

const FIRST_NAME 		= "First Name";
const LAST_NAME 		= "Last Name";
const GRADE_LEVEL 		= "Grade Level";
const CLASSROOM 		= "Classroom";
const TEACHER_EMAIL 	= "Teacher Email";
const PARENT_EMAIL 		= "Parent Email";
const USERNAME 			= "Username";
const PASSWORD 			= "Password";
const STUDENT_ID 		= "Student ID";
const WR_TEACHER_NAME 	= "WRTeacherName";
const IGNORE 			= "Unknown";

const REQUIRED_COLUMNS = [FIRST_NAME, LAST_NAME, GRADE_LEVEL, CLASSROOM];
const OPTIONAL_COLUMNS = [TEACHER_EMAIL, PARENT_EMAIL, USERNAME, PASSWORD, IGNORE];
const HIDDEN_COLUMNS = [WR_TEACHER_NAME]

const VISIBLE_COLUMNS = REQUIRED_COLUMNS.concat(OPTIONAL_COLUMNS);
const RECOGNIZED_COLUMNS = VISIBLE_COLUMNS.concat(HIDDEN_COLUMNS);

StudentRoster.Columns = {
	FIRST_NAME: 	FIRST_NAME,
	LAST_NAME: 		LAST_NAME,
	GRADE_LEVEL: 	GRADE_LEVEL,
	CLASSROOM: 		CLASSROOM,
	TEACHER_EMAIL: 	TEACHER_EMAIL,
	PARENT_EMAIL: 	PARENT_EMAIL,
	USERNAME: 		USERNAME,
	PASSWORD: 		PASSWORD,
	IGNORE: 		IGNORE,

	REQUIRED_COLUMNS: 	REQUIRED_COLUMNS,
	OPTIONAL_COLUMNS: 	OPTIONAL_COLUMNS,
	VISIBLE_COLUMNS: 	VISIBLE_COLUMNS,
	RECOGNIZED_COLUMNS:	RECOGNIZED_COLUMNS
}

const MIN_PASSWORD_LENGTH = 5;
StudentRoster.MIN_PASSWORD_LENGTH = MIN_PASSWORD_LENGTH;

module.exports = StudentRoster;


// WEBPACK FOOTER //
// ./modules/lib/data/StudentRoster.js